export { default as Img200 } from './processed/200/legend.jpg';
export { default as Img400 } from './processed/400/legend.jpg';
export { default as Img600 } from './processed/600/legend.jpg';
export { default as Imgthumb } from './processed/thumb/legend.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/legend.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/legend.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      235,
      36,
      53
    ],
    "_population": 1092,
    "_hsl": [
      0.9857621440536013,
      0.832635983263598,
      0.5313725490196078
    ]
  },
  "LightVibrant": {
    "_rgb": [
      252,
      84,
      148
    ],
    "_population": 1,
    "_hsl": [
      0.9365079365079364,
      0.9655172413793105,
      0.6588235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      133,
      167,
      35
    ],
    "_population": 287,
    "_hsl": [
      0.20959595959595956,
      0.6534653465346534,
      0.39607843137254906
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      120,
      109
    ],
    "_population": 1204,
    "_hsl": [
      0.042635658914728695,
      0.17269076305220887,
      0.5117647058823529
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      190,
      172
    ],
    "_population": 2305,
    "_hsl": [
      0.14285714285714293,
      0.14482758620689642,
      0.7156862745098039
    ]
  },
  "DarkMuted": {
    "_rgb": [
      95,
      64,
      57
    ],
    "_population": 2079,
    "_hsl": [
      0.030701754385964897,
      0.25,
      0.2980392156862745
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/legend.js